import React from 'react';
import { FormHelperText } from '@mui/material';

const InputFieldErrorMessage = ({ touched, error }) => {
    return (
        <FormHelperText
            sx={{
                color: '#F04134',
                minHeight: '1.15rem',
                lineHeight: 1.2,
                visibility: touched && error ? 'visible' : 'hidden'
            }}
        >
            {touched && error}
        </FormHelperText>
    );
};

export default InputFieldErrorMessage;
